module.exports = __webpack_public_path__ + "videos/mts-products-chats-adding-employees.740f99e.webm";